import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { RootState } from '@app/redux/interface';

export const getBranchEnvironmentState = (state: RootState) => state.branchEnvironment;

export const getBranchEnvironment = createDraftSafeSelector(
	getBranchEnvironmentState,
	branchEnvironmentState => branchEnvironmentState.variables,
);

export const getIsBranchEnvironmentUpdated = createDraftSafeSelector(
	getBranchEnvironmentState,
	branchEnvironmentState => branchEnvironmentState.isUpdated,
);
